/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { RectStruct } from './rect-struct';

export class FSFBViewDebug {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FSFBViewDebug {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFSFBViewDebug(bb: flatbuffers.ByteBuffer, obj?: FSFBViewDebug): FSFBViewDebug {
    return (obj || new FSFBViewDebug()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFSFBViewDebug(
    bb: flatbuffers.ByteBuffer,
    obj?: FSFBViewDebug,
  ): FSFBViewDebug {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FSFBViewDebug()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  viewId64(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
  }

  parentViewId64(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
  }

  optimizations(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : 0;
  }

  clip(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  viewHierarchySize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  viewCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startFSFBViewDebug(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addViewId64(builder: flatbuffers.Builder, viewId64: bigint) {
    builder.addFieldInt64(0, viewId64, BigInt('0'));
  }

  static addParentViewId64(builder: flatbuffers.Builder, parentViewId64: bigint) {
    builder.addFieldInt64(1, parentViewId64, BigInt('0'));
  }

  static addOptimizations(builder: flatbuffers.Builder, optimizations: number) {
    builder.addFieldInt8(2, optimizations, 0);
  }

  static addClip(builder: flatbuffers.Builder, clipOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, clipOffset, 0);
  }

  static addViewHierarchySize(builder: flatbuffers.Builder, viewHierarchySize: number) {
    builder.addFieldInt32(4, viewHierarchySize, 0);
  }

  static addViewCount(builder: flatbuffers.Builder, viewCount: number) {
    builder.addFieldInt32(5, viewCount, 0);
  }

  static endFSFBViewDebug(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
